exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[type=\"text\"][data-v-3018cbb6] {\n\tfont-size:16px;\n}\n.task-title.field-value[data-v-3018cbb6] {\n\tpadding-top: 21px;\npadding-left: 20px;\n}\ninput[type=\"text\"].form-control.title-field[data-v-3018cbb6] {\n\tfont-size:16px;\n}\n", ""]);

// exports
